import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const UserStatusChart = ({ totalUsers, deletedUsers }) => {
  const activeUsers = totalUsers - deletedUsers;
  const data = [
    {
      metric: "User Metrics",
      Total: totalUsers,
      Active: activeUsers,
      Deleted: deletedUsers,
    },
  ];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="metric" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="Total" fill="#8884d8" name="Total Users" />
        <Bar dataKey="Active" fill="#82ca9d" name="Active Users" />
        <Bar dataKey="Deleted" fill="#ff6b6b" name="Deleted Users" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default UserStatusChart;
